module.exports = __webpack_public_path__ + "img/jianzhu_bg.44be40cf.png";